<template>
  <div class="form-wrap">
    <h4 class="title">General Inquiry</h4>
    <form ref="generalInquiry" class="form" novalidate @submit.prevent="validate">
      <div class="row">
        <div class="col">
          <div class="mt-20">
            <a
              target="_blank"
              href="/docs/vet-new-prescription.pdf"
            >Download Veterinarian New Prescription Form</a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-wrap">
            <div class="icon icon-user"/>
            <input
              id="name"
              v-model.trim="inquiry.name"
              :class="{ 'error': $v.inquiry.name.$error }"
              type="text"
              name="name"
              placeholder="Your Name (Required)"
              required="required"
              class="input LoNotSensitive"
              @input="$v.inquiry.name.$touch()"
            >
            <label
              v-if="$v.inquiry.name.$error && !$v.inquiry.name.required"
              class="error"
              for="name"
            >This field is required.</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-wrap">
            <div class="icon icon-phone"/>
            <input
              v-mask="'(###) ###-####'"
              id="phone"
              v-model="inquiry.phone"
              :class="{ 'error': $v.inquiry.phone.$error }"
              type="tel"
              name="phone"
              placeholder="Your Phone Number"
              required="required"
              class="input LoNotSensitive"
              @input="$v.inquiry.phone.$touch()"
            >
            <label
              v-if="$v.inquiry.phone.$error && !$v.inquiry.phone.required"
              class="error"
              for="name"
            >This field is required.</label>
            <label
              v-if="$v.inquiry.phone.$error && !$v.inquiry.phone.minLength"
              class="error"
              for="name"
            >Minimal length is 10 numbers.</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-wrap">
            <div class="icon icon-mail"/>
            <input
              id="email"
              v-model.trim="inquiry.email"
              :class="{ 'error': $v.inquiry.email.$error }"
              type="text"
              name="email"
              placeholder="Your Email (Required)"
              required="required"
              class="input LoNotSensitive"
              @input="$v.inquiry.email.$touch()"
            >
            <label
              v-if="$v.inquiry.email.$error && !$v.inquiry.email.required"
              class="error"
              for="name"
            >This field is required.</label>
            <label
              v-if="$v.inquiry.email.$error && !$v.inquiry.email.email"
              class="error"
              for="name"
            >Valid email is required.</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-wrap">
            <div class="icon icon-pen"/>
            <textarea
              id="message"
              v-model="inquiry.message"
              name="message"
              placeholder="Your Message"
              required="required"
              class="textarea LoNotSensitive"
              maxlength="500"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-file-wrap">
            <div class="file-wrap"/>
            <div class="button">
              <div class="icon icon-upload"/>
              <span class="placeholder">File upload (formats: jpg, png, pdf, doc, docx 1mb limit)</span>
            </div>
            <div class="file-input">
              <input ref="file" type="file" name="addfile[]" class="input-file clone" >
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <vue-recaptcha
            ref="recaptcha"
            :load-recaptcha-script="true"
            :sitekey="sitekey"
            size="invisible"
            @verify="submit"
            @expired="onCaptchaExpired"
          />
          <vue-button-spinner
            :is-loading="isLoading"
            :disabled="isLoading"
            :status="status"
            type="submit"
            class="btn wide">
            <span>Send</span>
          </vue-button-spinner>
        </div>
      </div>
      <sweet-modal ref="general_modal" :blocking="true" :hide-close-button="true">
        <div style="text-align: center;">
          <div class="modal-close-btn cross">
            <span class="icon-cross" />
          </div>
          <div class="modal-body">
            <h2 class="title">Success!</h2>
            <div class="notification-block">
              <p>We have received your message.<br>We will contact you as soon as possible.</p>
              <div class="button-wrap">
                <button
                  class="btn modal-close-btn"
                  style="margin: 15px auto 0;"
                  @click="confirmModal"
                >Ok</button>
              </div>
            </div>
          </div>
        </div>
      </sweet-modal>
    </form>
  </div>
</template>

<script>
/* global axios, gtag */
import { required, minLength, email } from 'vuelidate/lib/validators'
import { SweetModal } from 'sweet-modal-vue'
import VueRecaptcha from 'vue-recaptcha'
import ValidateScroll from '../../mixins/ValidateScroll'

export default {
  name: 'GeneralInquiry',
  components: {
    VueRecaptcha,
    SweetModal
  },
  mixins: [ValidateScroll],
  data: () => {
    return {
      inquiry: {},
      sitekey: process.env.RECAPTCHA_SITE_KEY,
      isLoading: false,
      status: ''
    }
  },
  validations: {
    inquiry: {
      name: {
        required
      },
      email: {
        required,
        email
      },
      phone: {
        required,
        minLength: minLength(10)
      }
    }
  },
  methods: {
    submit (recaptchaToken) {
      if (!this.$v.$invalid) {
        this.isLoading = true
        let formData = new FormData()

        formData.append('type', 'general')

        for (var key in this.inquiry) {
          formData.append(key, this.inquiry[key])
        }
        formData.append('recaptcha_token', recaptchaToken)

        let filesArray = []

        this.$refs.generalInquiry
          .querySelectorAll('input[type=file]')
          .forEach(item => {
            if (item.files.length !== 0) {
              for (let newFile of Array.from(item.files)) {
                filesArray.push(newFile)
              }
            }
          })

        filesArray.forEach(item => {
          formData.append('documents[]', item)
        })

        axios
          .post('/api/forms/submit', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              this.$refs.general_modal.open()
              this.isLoading = false
              if (Object.keys(window).indexOf('gtag') !== -1) {
                gtag('event', 'sent', {
                  event_category: 'form',
                  event_label: 'contact',
                  value: 1
                })
              }
            } else {
              console.log(response.data.message)
              this.isLoading = false
            }
          })
          .catch(error => {
            console.log(error)
            this.isLoading = false
          })
      }
    },
    confirmModal () {
      let that = this
      this.$refs.generalInquiry
        .querySelectorAll('input[type=file]')
        .forEach(item => {
          if (item.files.length !== 0) {
            let dataId = item.getAttribute('data-id')
            that.$refs.generalInquiry
              .querySelector('.file[data-id="' + dataId + '"]')
              .remove()
            item.remove()
          }
        })
      this.inquiry = {}
      this.$nextTick(() => {
        that.$refs.recaptcha.reset()
        that.$v.$reset()
        that.$refs.general_modal.close()
      })
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    validate () {
      this.validateWithScroll()
      if (!this.$v.$invalid) {
        this.$refs.recaptcha.execute()
      }
    }
  }
}
</script>

<style>
h4.title {
  margin: 0 !important;
}
.vue-btn {
  display: flex !important;
    -webkit-box-align: center !important;
    -webkit-align-items: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
    -webkit-box-pack: center !important;
    -webkit-justify-content: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
    width: 100% !important;
    height: 50px !important;
    max-width: 390px !important;
    padding: 5px 30px !important;
    color: #fff !important;
    font-size: 18px !important;
    line-height: normal !important;
    text-align: center !important;
    border: 2px solid #842938 !important;
    cursor: pointer !important;
    transition: .3s !important;
    -webkit-border-radius: 5px !important;
    border-radius: 5px !important;
    background: #842938 !important;
    margin: 15px auto 0 !important;
}
.vue-btn:disabled {
  cursor: not-allowed !important;
}
.spinner {
  height: 30px !important;
  width: 30px !important;
}
</style>
